export default "__VITE_PUBLIC_ASSET__d70f2205__"